/* unplugin-vue-components disabled */import { render } from "./QuestionReviewRenderPage.vue?vue&type=template&id=946f2bdc&scoped=true"
import script from "./QuestionReviewRenderPage.vue?vue&type=script&lang=js"
export * from "./QuestionReviewRenderPage.vue?vue&type=script&lang=js"

import "./QuestionReviewRenderPage.vue?vue&type=style&index=0&id=946f2bdc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-946f2bdc"]])

export default __exports__